import axiosProvider from "./axios-interceptor.js";
import logService from './log-service.js';

async function getJHNavOfficeSearch(searchStringOrObject) {
  var url;
  if (typeof searchStringOrObject === "object") {
    url =
      "/api/offices/search?customerAddress%5Blatitude%5D=" +
      searchStringOrObject.coords.latitude +
      "&customerAddress%5Blongitude%5D=" +
      searchStringOrObject.coords.longitude;
  } else {
    url = "/api/offices/search/" + searchStringOrObject;
  }
    return await axiosProvider
    .get(url, { retry: 3, retryDelay: 3000 })
    .then((response) => response.data)
    .catch((error) => {
      logService.errorLog(JSON.stringify(error));
      var zipcode = typeof(searchStringOrObject) != "object" ? `?search=${searchStringOrObject}`:"";
      window.location.href = window.location.hostname === "localhost" ?
        `http://` + window.location.host + `/officelocator${zipcode}` : `https://` + window.location.hostname + `/officelocator${zipcode}`;

    });
}

export default {
  getJHNavOfficeSearch,
};